module.exports = __webpack_public_path__ + "./images/way.jpeg?58de90c9e1afefcb85d18780ed04349b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/way.jpeg
// module id = 8
// module chunks = 0